import React from "react";
import Chart from "react-apexcharts";
import { Card, CardContent } from "@mui/material";
import MaterialBox from "../../../../components/MaterialBox";
import MaterialTypography from "../../../../components/MaterialTypography";
import dayjs from "dayjs";

const PerformanceChart = () => {
    const currentMonth = dayjs().format("MMMM");
    const previousMonth = dayjs().subtract(1, "month").format("MMMM");

    const series = [
        {
            name: "Current Month",
            data: [30, 40, 35, 50, 49, 60, 70, 91, 125],
        },
        {
            name: "Previous Month",
            data: [20, 30, 25, 40, 39, 50, 30, 40, 50],
        },
    ];

    const options = {
        chart: {
            type: "line",
            toolbar: {
                show: false,
            },
            zoom: {
                enabled: false,
            },
        },
        colors: ["#5e72e4", "#d3d3d3"], // Purple and Light Grey
        dataLabels: {
            enabled: false,
        },
        stroke: {
            curve: "smooth",
            width: 3,
        },
        grid: {
            show: false,
        },
        xaxis: {
            labels: {
                show: false,
            },
            axisBorder: {
                show: false,
            },
            axisTicks: {
                show: false,
            },
        },
        yaxis: {
            labels: {
                show: false,
            },
        },
        legend: {
            show: false,
        },
        tooltip: {
            x: {
                show: false,
            },
        },
    };

    return (
        <Card sx={{ borderRadius: 4, boxShadow: "0 4px 20px 0 rgba(0,0,0,0.05)", height: '100%' }}>
            <CardContent sx={{ p: 2, "&:last-child": { pb: 2 } }}>
                <MaterialBox sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", mb: 1 }}>
                    <MaterialBox>
                        <MaterialTypography variant="h6" fontWeight="bold" sx={{ color: "#344767", fontSize: '1rem' }}>
                            Your Performance RPI
                        </MaterialTypography>
                        <MaterialTypography variant="caption" sx={{ color: "#67748e" }}>
                            Compared to {previousMonth}
                        </MaterialTypography>
                    </MaterialBox>
                    <MaterialTypography variant="button" fontWeight="bold" sx={{ color: "#2dce89", fontSize: '0.8rem' }}>
                        +26%
                    </MaterialTypography>
                </MaterialBox>

                <MaterialBox sx={{ mt: -6, mb: -2 }}>
                    <Chart options={options} series={series} type="line" height={150} />
                </MaterialBox>

                <MaterialBox sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 0 }}>
                    <MaterialBox sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <MaterialBox
                            sx={{
                                width: 8,
                                height: 8,
                                borderRadius: "50%",
                                backgroundColor: "#5e72e4",
                            }}
                        />
                        <MaterialTypography variant="caption" fontWeight="medium">
                            {currentMonth} Comparison
                        </MaterialTypography>
                    </MaterialBox>
                    <MaterialTypography variant="h6" fontWeight="bold" sx={{ color: "#344767", fontSize: '0.9rem' }}>
                        6,877
                    </MaterialTypography>
                </MaterialBox>
            </CardContent>
        </Card>
    );
};

export default PerformanceChart;
